export function noZero(price) {
  if (parseFloat(price) === 0) {
    return null;
  }
  return price;
}
